// extracted by mini-css-extract-plugin
module.exports = {"--space-1x":"8px","space1X":"8px","icon":"icon-QVRj1BLxGr","time":"time-2GGcg2yf_s"};